goog.provide("shadow.js.shim.module$src$svg$objects$bookmark_svg$default");
shadow.js.shim.module$src$svg$objects$bookmark_svg$default = shadow.js.shim.module$src$svg$objects$bookmark_svg.default;
